import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroMuros= () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          {/* Columna izquierda con imagen y características */}
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src="assets/img/recubrimientos-muros/recubrimientos-muros-intro.jpg" alt="Recubrimientos para muros que transforman tus espacios" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Fácil instalación"
                  descripcion="Materiales listos para instalación, fáciles de cortar y fijar. Opciones resistentes al agua, humedad y rayos UV."
                />
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Uso en interiores y exteriores"
                  descripcion="Variedad de acabados, colores y texturas para adaptarse a diferentes estilos de diseño, en interior y exterior."
                />
              </div>
            </div>
          </div>
          
          {/* Columna derecha con título y párrafo */}
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Entrega Inmediata</span>
                <h2 className="h1 mb-4">Recubrimientos para muros que transforman tus espacios</h2>
                <p className="mb-0">
                En Decototal entendemos que cada proyecto necesita materiales que inspiren, que sean versátiles y que eleven el diseño con soluciones de instalación 
                rápida y apariencia impecable. Nuestra colección de recubrimientos para muros ofrece una gama cuidadosamente seleccionada de materiales sintéticos y 
                ecológicos para interiores y exteriores, ideales para todo tipo de ambientes comerciales y residenciales.
                </p>
              </div>
              <BannerNoInstalacion />
              <img src="/assets/img/recubrimientos-muros/recubrimientos-muros-intro-2.jpg" alt="Recubrimientos para muros" /> 
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las características individuales
const FeatureItem = ({ imgSrc, titulo, descripcion }) => {
  return (
    <div className="d-flex border-bottom pb-1-9 mb-1-9">
      <div className="flex-shrink-0 me-4">
        <img src={imgSrc} alt={titulo} />
      </div>
      <div className="flex-grow-1">
        <h4 className="h5">{titulo}</h4>
        <p className="mb-0">{descripcion}</p>
      </div>
    </div>
  );
};

export default IntroMuros;
